export const SET_TASK_INVOICE_DETAIL_DATA = "SET_TASK_INVOICE_DETAIL_DATA";
export const RESET_TASK_INVOICE_REDUCER = "RESET_TASK_INVOICE_REDUCER";